import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Form from 'react-bootstrap/Form'
import { useFacultyGroupStore } from "../../stores"
import "./FacultyGroup.css";
import FacultyContent from "./FacultyContent";
import { useState } from "react";
const FacultyGroup = () => {
  const navigate = useNavigate();
  const [subject, setSubject] = useState(null);
  const { section, batch } = useParams();
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category"), exam = searchParams.get("exam");
  const addAll = useFacultyGroupStore(state => state.addAll);
  const subjects = useFacultyGroupStore(state => state.subjects);
  const getFaculties = useFacultyGroupStore(state => state.getFaculties);
  const loading = useFacultyGroupStore(state => state.loading);
  const setLoading = useFacultyGroupStore(state => state.setLoading);
  useEffect(() => {
    let url = `/api/file/subjects/${section}?batch=${batch}&category=${category}`;
    if (exam) {
      url += `&exam=${exam}`;
    }
    fetch(url).then(r => {
      if (r.status !== 200) {
        console.log(r.statusText);
      }
      else {
        r.json().then(res => {
          addAll(res);
          setSubject(subject || (subjects[0] ? subjects[0]._id : null));
        })
      }
    })
  }, [])
  if (loading) {
    return <>
      <h5>Loading</h5>
    </>
  }
  return (
    <div className="container-fluid">
      <div className="p-2">
        {/* <pre>
          {JSON.stringify(subjects, null, 4)}
        </pre> */}
        <h4>Subject_Name</h4>
        <Form.Select onChange={(e) => setSubject(e.target.value)}>
          {
            subjects.map((sub, ind) => <option key={ind} selected={ind === 0} value={sub._id}>{sub.name}</option>)
          }
        </Form.Select>
        <div className="row facultygroup p-2">
          {
            getFaculties(subject || (subjects[0] ? subjects[0]._id : null)).map((fac, ind) => <FacultyContent key={ind} data={fac} subject={subject || (subjects[0] ? subjects[0]._id : null)} section={section} category={category} batch={batch} exam={exam}/>)
          }
        </div>
      </div>
    </div>
  );
};

export default FacultyGroup;
